<template>
  <div class="container text-left">
    <div class="row mt-4">
      <div class="col" />
      <div class="col text-center">
        <h3>Tutorials</h3>
      </div>
      <div class="col text-right">
        <input
          v-model="searchKeyword"
          class="form-control"
          style="width: auto; display:initial;"
          placeholder="Search Keyword"
        />
      </div>
    </div>
    <div
      class="row pt-2"
    >
      <div v-for="tutorial in filterTutorials(tutorials)"
        :key="tutorial.Tutorial_Id"
        class="col-12">
        <p class="mb-1">
          <b>{{ tutorial.Title }}</b>
        </p>
        <iframe
          width="560"
          height="315"
          v-bind:src="tutorial.URL"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tutorials",
  data() {
    return {
      tutorials: [],
      searchKeyword: ""
    };
  },
  components: {},
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.tutorials = await view.$getTutorials();
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    filterTutorials(tutorials) {
      if (this.searchKeyword != "") {
        var lowerKeyword = this.searchKeyword.toLowerCase();
        return tutorials
          .filter(
            t =>
              t.Title.toLowerCase().includes(lowerKeyword) ||
              t.Description.toLowerCase().includes(lowerKeyword)
          )
          .slice()
          .sort(this.$orderByTitle);
      } else {
        return tutorials.slice().sort(this.$orderByTitle);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
